<div class="container">
    <div class="col-sm-12 padding-top-50px">
        <div class="col-sm-10 error-info-block">
            <span class="fa fa-exclamation-triangle font-size-6 padding-right-20px"></span>
            <span class="vertical-align-top">Your account does not have permission to perform the requested action.</span>
        </div>
    </div>
</div>